export class CalendarEventRole {
    //netgen start
    calendarEventId = 0;
    roleId: number = null;
    responsibleId: number = null;
    id = 0;
    //netgen end
}
